import store from '../store'
import Wallkit from '../plugins/wallkit.esm.min.js';
import debug from '../utils/debug';

export default async (to, from, next) => {
  if (store.getters['resource/resource_key'] && !store.getters['resource/resource']) {
    Wallkit.getResource()
      .then(data => {
        next();
      })
      .catch(error => {
        debug.log("resource middleware error", error);
        next();
      })
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./src/middlewares/resource.js